
import { MutationTypes as AuthMutationTypes } from "@/store/modules/auth";
import { MutationTypes as UserMutationTypes } from "@/store/modules/user";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: String,
    userButton: Boolean,
  },
  computed: {
    me() {
      return this.$store.getters["user/getMe"];
    },
    editionName() {
      return this.$store.getters["edition/getEditionName"];
    },
  },
  methods: {
    home() {
      this.$router.push({ name: "Home" });
    },
    settings() {
      this.$router.push({ name: "userSettings" });
    },
    async disconnect() {
      await axios.post("logout", {
        refreshToken: this.$store.getters["auth/getRefreshToken"],
      });
      this.$store.commit(`auth/${AuthMutationTypes.LOGOUT}`);
      this.$store.commit(`user/${UserMutationTypes.SET_USER_ME}`, {});
      this.$router.push({ name: "Login" });
    },
  },
});
